import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
import HookInput from "@/app/components/common-form-builder/common-fields/hook-input/HookInput";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { FieldValues, UseFormReturn } from "react-hook-form";

type Props = {
  fields: IField[];
  form: UseFormReturn<FieldValues, any>;
};

const RegisterMainFields: React.FC<Props> = ({ form, fields }) => {
  const t = useTranslation();
  const {
    register,
    formState: { errors },
    getValues,
    setError,
  } = form;
  const requiredMsg = t.this_field_is_required;
  const matchedMsg = t.passwords_should_match;
  const passwordLengthMsg = t.at_least_8_char;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 24,
        marginBottom: 24,
      }}
    >
      {fields?.map((field) => (
        <CommonFormBuilder
          key={field?.configurations.key}
          form={form}
          field={field}
        />
      ))}
      <HookInput
        label={t.password}
        type="password"
        inputRegister={{
          ...register("password", {
            validate: (value) => {
              if (!value) {
                setError("password_confirmation", { message: undefined });
                return requiredMsg;
              }
              const { password_confirmation } = getValues();
              if (value === password_confirmation)
                setError("password_confirmation", { message: undefined });
              else setError("password_confirmation", { message: matchedMsg });
              if (value.length < 8) return passwordLengthMsg;
              return true;
            },
          }),
        }}
        errorMsg={errors.password?.message as string}
      />
      <HookInput
        type="password"
        label={t.confirm_password}
        inputRegister={{
          ...register("password_confirmation", {
            validate: {
              matchesPreviousPassword: (value) => {
                const { password } = getValues();
                if (!value && !!password) return requiredMsg;
                return password === value || matchedMsg;
              },
            },
          }),
        }}
        errorMsg={errors.password_confirmation?.message as string}
      />
    </div>
  );
};

export default RegisterMainFields;
